import React, { FC } from "react"
import { GroupWrap } from "components/group-wrap/group-wrap"
import FACEBOOK from "assets/icons/social/fb.svg"
import LINKEDIN from "assets/icons/social/li.svg"
import TIK_TOK from "assets/icons/social/tiktok.svg"
import INSTAGRAM from "assets/icons/social/ig.svg"
import { CustomIcon } from "components/custom-icon/CustomIcon"

const buttons = [
  {
    src: FACEBOOK,
    href: "https://www.facebook.com/tutorspaceDE/",
  },
  {
    src: INSTAGRAM,
    href: "https://www.instagram.com/tutorspace_nachhilfe/",
  },
  {
    src: LINKEDIN,
    href: "https://www.linkedin.com/company/tutorspace/",
  },
  {
    src: TIK_TOK,
    href: "https://www.tiktok.com/@tutorspace",
  },
]

export const SocialButtons: FC = () => {
  return (
    <GroupWrap gap={1}>
      {buttons.map(({ src, href }, idx) => (
        <a href={href} key={idx} target={"_blank"} rel={"noreferrer"}>
          <CustomIcon src={src} height={32} width={32} />
        </a>
      ))}
    </GroupWrap>
  )
}
